import { ValidationDisplayMode } from './Validation/Misc';
import { DataType } from './Model/Misc';
export var Settings = {
    /** Specify this if your app has a header that is fixed to the top of the screen. */
    fixedAppHeaderElement: null,
    /**
     * Time the css animation takes to show / hide a modal. Note: This must match the css animation time.
     */
    modalAnimationTimeMs: 300,
    form: {
        validationDisplayMode: ValidationDisplayMode.AfterBlur,
    },
    icons: {
        loadingIcon: "fa-circle-notch",
        errorIcon: "fa-exclamation-triangle",
        warningIcon: "fa-exclamation-triangle",
        infoIcon: "fa-exclamation-circle",
        expanded: "far-minus-square",
        collapsed: "far-plus-square",
        sortAsc: "sort-up",
        sortDesc: "sort-down",
        /** Icon used in back buttons */
        backIcon: "arrow-left",
    },
    /** Grid default settings */
    grid: {
        /** Causes the table to have a border, cells will also have a left and right border. True by default. */
        isBordered: true,
        /** When specified, every alternating row will receive a slightly darker background color. */
        isStriped: false,
        /** Removes the default top and bottom borders from rows. */
        isBorderless: false,
        /** When specified, a background color will be applied on a row if it is being hovered over. */
        showHover: false,
        /** When specified, the table size will be reduced (by reducing the padding sizes in each cell by half). */
        isSmallTable: false,
        addButton: {
            text: "Add",
            variant: "primary",
            icon: "plus"
        },
        editButton: {
            text: "Edit",
            variant: "warning",
            icon: "edit",
            tabIndex: -1
        },
        deleteButton: {
            text: "Delete",
            variant: "danger",
            icon: "trash",
            tabIndex: -1
        },
        viewButton: {
            text: "View",
            variant: "info",
            icon: "arrow-right",
            iconAlignment: "right",
            tabIndex: -1
        },
        expandButton: {
            variant: "light",
            size: "sm",
            tabIndex: -1
        },
        boolTrueClass: "far fa-lg fa-check-square",
        boolFalseClass: "far fa-lg fa-square text-light",
        /**
         * Will cause headers to stick to the top of the screen / scroll element when scrolling.
         * This will apply to all NeoGrids, but can be overridden per grid.
         */
        useStickyHeaders: false,
    },
    modal: {
        /** Set to true if ModalUtils.showMessage() should show an accept button instead of close button. */
        okIsAccept: false,
        acceptButton: {
            text: "Ok",
            variant: "primary"
        },
        /** Settings for close button shown in footer. */
        closeButton: {
            text: "Close",
            variant: "secondary"
        },
        /** Settings for cancel button shown in footer. */
        cancelButton: {
            variant: "light",
            isOutline: false,
        },
    },
    pager: {
        firstText: "«",
        prevText: "‹",
        nextText: "›",
        lastText: "»",
        /** Default list of page sizes to show in the page size drop down control. */
        pageSizeOptions: [10, 20, 50]
    },
    fileManager: {
        /** These extensions are not allowed. Must be lower case. */
        disallowedFileExtensions: [".exe", ".bat", ".cmd", ".sh", ".com", ".ps", ".ps1", ".dll"],
        /** Global allowed extensions. Can be changed on each file upload manager. Must be lower case. */
        allowedExtensions: [],
        fileEditorButton: { variant: "dark" }
    },
    progressBar: {
        /** True if you want the animation to be reversed globally. */
        reverse: false
    },
    /** Data types which must sort by descending when first sorted. */
    sortDescendingTypes: [DataType.Float, DataType.Int, DataType.Decimal],
    notifications: {
        /** The standard notification duration in seconds. */
        standardDuration: 4
    }
};
